export default __webpack_public_path__ + "static/media/antp_nom015_17oct_portada-.47d71188.jpg";